import React, { useState, useEffect } from 'react';
import Buscador from './conponents/Buscador'
import ListadoImagenes from './conponents/ListadoImagenes'

function App() {

  const [busqueda, guardarBusqueda] = useState('');
  const [imagenes, guardarImagenes] = useState([]);
  const [ paginaActual, guardarPaginaActual ] = useState(1);
  const [ totalPaginas, guardarTotalPaginas ] = useState(1);

  useEffect(() => {

    if(busqueda === '') return;

    const consultarAPI = async () => {
      const key = '13385747-a1e0031ad5c07edfd76e7369d'
      const imagenesPorPagina = 30
      const url = `https://pixabay.com/api/?key=${key}&q=${busqueda}&per_page=${imagenesPorPagina}&page=${paginaActual}`

      const req = await fetch(url);
      const res = await req.json();

      guardarImagenes(res.hits);

      // calcuar páginas
      const calcularTotalPaguinas = Math.ceil(res.totalHits / imagenesPorPagina);
      guardarTotalPaginas(calcularTotalPaguinas)

      // subir hacia la parte superior
      const jumbo = document.querySelection('.jumbotron');
      jumbo.scrollIntoView({behavior:'smooth', block:'end'});

    }
    consultarAPI()

  }, [busqueda, paginaActual])

  const paginaAnterior = () => {
    let nuevaPaginaActual = paginaActual - 1 ;
    guardarPaginaActual(nuevaPaginaActual)
  }
  const paginaSigiente = () => {
    let nuevaPaginaActual = paginaActual + 1;
    guardarPaginaActual(nuevaPaginaActual)
  }

  return (
    <div className="app container">
      <div className="jumbotron">
        <p className="lead text-center">Buscador de imágenes</p>
        <Buscador
          guardarBusqueda={guardarBusqueda}
        />
      </div>
      <div className="row justify-content-center">
        <ListadoImagenes 
          imagenes={imagenes}
        />
        {(paginaActual === 1) ? null : (
          <button onClick={paginaAnterior} type="button" className="btn btn-info mr-1">&laquo; Anterior</button>
        )}
        {(paginaActual === totalPaginas) ? null : (
          <button onClick={paginaSigiente} type="button" className="btn btn-info mr-1">Siguiente &raquo;</button>
        )}
      </div> 
    </div>
  );
}

export default App;
